import { TonConnectButton, useTonAddress } from '@tonconnect/ui-react';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TON_NETWORK } from '../ton/config';
import { LanguageSwitcher } from './LanguageSwitcher';
import { PyramidSpinner } from './PyramidSpinner';

interface HeaderV2Props {
  renderWalletControl: boolean;
  onOpenProfile: () => void;
  onGoHome: () => void;
}

/** v2 header: spinning-pyramid brand mark (same as the partner header),
 *  wallet control and the profile-sheet button. */
export function HeaderV2({ renderWalletControl, onOpenProfile, onGoHome }: HeaderV2Props) {
  const address = useTonAddress();
  const { t } = useTranslation();

  return (
    <header className={`app-header header-v2${address ? ' app-header--wallet' : ''}`}>
      <button
        type="button"
        className="app-header__brand brand-button"
        onClick={onGoHome}
        aria-label={t('v2.nav.play')}
      >
        <PyramidSpinner className="header-v2__pyramid" size={30} />
        <img src="/text-logo.webp" alt="PRMD" className="app-header__logo" />
        {TON_NETWORK !== 'mainnet' && (
          <span className={`network-badge network-badge--${TON_NETWORK}`}>{TON_NETWORK}</span>
        )}
      </button>
      <div className="app-header__actions">
        {address && renderWalletControl && <TonConnectButton className="ton-connect-compact" />}
        <LanguageSwitcher className="lang-switcher--compact" />
        <button
          type="button"
          className="header-v2__menu"
          onClick={onOpenProfile}
          aria-label={t('v2.profile.open')}
        >
          <Menu size={20} aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
